export const feedbackStatsExampleData = {
  stars: 4.8,
  customerReviews: 4123
};

export const feedbackExampleData = {
  picture: "https://source.unsplash.com/random/1000x1000",
  pictureAlt: "Flying Pig logo design variant",
  avatar: "https://randomuser.me/api/portraits/thumb/men/75.jpg",
  fullName: "Spoon Lancer",
  mainCitation: "Very happy with DesignContest professionalism.",
  fullCitation:
    "We couldn't be happier with the professionalism of Design Contest. The variety of designs and thought that went into the project opened the creative possibilities of where we could go next as a company with our logo and brand.",
  designers: 433,
  entries: 1392,
  budget: 372
};
